import { render } from "./AdminView.vue?vue&type=template&id=4142eba8&ts=true"
import script from "./AdminView.vue?vue&type=script&lang=ts"
export * from "./AdminView.vue?vue&type=script&lang=ts"

import "./AdminView.vue?vue&type=style&index=0&id=4142eba8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__